<template>
  <div>
    <BjImportFile ref="BjImportFile" :limit-size="128 * 1024" auto-upload @importFile="importFile">
      <template #top></template>
      <template slot="default">只能上传文件</template>
    </BjImportFile>
  </div>
</template>

<script>
import papa from 'papaparse';
export default {
    methods: {
        importFile(file) {
            const reader = new FileReader();
            reader.readAsArrayBuffer(file);
            reader.onload = function () {
                const buffer = reader.result;
                const bytes = new Uint8Array(buffer);
                const length = bytes.byteLength;
                let binary = '';
                for (let i = 0; i < length; i++) {
                    binary += String.fromCharCode(bytes[i]);
                }
                const XLSX = require('xlsx');
                const wb = XLSX.read(binary, {
                    type: 'binary',
                });
                const excelData = XLSX.utils.sheet_to_json(wb.Sheets[wb.SheetNames[0]], { header: 1 })[0];
                const outData = XLSX.utils.sheet_to_json(wb.Sheets[wb.SheetNames[0]]);
                const duplicateRows = outData.filter((row, index) => {
                    return (index !== outData.findIndex((r) => JSON.stringify(r['PO #']) === JSON.stringify(row['PO #'])));
                });
                const csvData = outData.filter((row) => {
                    return duplicateRows.some(r => JSON.stringify(row['PO #']) === JSON.stringify(r['PO #']));
                });

                const resultData = csvData.map(obj => {
                    const keys = Object.keys(obj);
                    const tempObj = {};
                    excelData.forEach(key => {
                        if (!tempObj[key] && keys.includes(key)) {
                            tempObj[key] = obj[key];
                        } else {
                            tempObj[key] = '';
                        }
                    });
                    return tempObj;
                });
                if (!resultData.length) return;
                const csv = papa.unparse(resultData);
                const data = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
                const csvURL = window.URL.createObjectURL(data);
                const download = document.createElement('a');
                download.href = csvURL;
                download.setAttribute('download', 'duplicateRows.csv');
                download.click();
            };
        },
    },
};
</script>
